import { styled } from '@mui/material';

export const HeadersLinkStyled = styled('div')(({ theme }) => ({
  '@media(min-width: 751px)': {
    display: 'none',
  },
  padding: '16px 28px 28px 24px',
  color: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '& a': {
    textDecoration: 'underline',
    color: theme.palette.secondary.main,
    fontFamily: 'montserrat',
    fontSize: 13,
  },
}));
